export const DEFAULT_INSTALMENT_ALV_PERCENTAGE = 25.5;

const toFiniteNumber = (value, fallback) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

// Gross sum derived from the tax-free sum, rounded to cents — gross is never
// stored, and every display path renders this value directly.
export const deriveGross = (taxFreeSum, alvPercentage) => {
  const net = toFiniteNumber(taxFreeSum, 0);
  const percentage = toFiniteNumber(
    alvPercentage,
    DEFAULT_INSTALMENT_ALV_PERCENTAGE
  );
  return Math.round(net * (1 + percentage / 100) * 100) / 100;
};

// Strips local-only display fields (key/index and the derived sum; __typename
// defensively for rows persisted in the Apollo era) and forces the numeric
// fields to real numbers before rows are sent to the API. Rows are replaced
// wholesale on the backend, so a cleared input ('') must become 0 here — the
// backend drops non-numeric values rather than storing them.
export const toApiInstalmentRows = (rows) =>
  (rows || []).map(({ key, index, sum, __typename, ...row }) => ({
    ...row,
    taxFreeSum: toFiniteNumber(row.taxFreeSum, 0),
    alvPercentage: toFiniteNumber(
      row.alvPercentage,
      DEFAULT_INSTALMENT_ALV_PERCENTAGE
    ),
  }));
